/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="85.16" height="94.35" viewBox="0 0 85.16 94.35" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <g>
      <path d="M53.52,51.83a1.25,1.25,0,0,1,.12,2.49H46.4A8.88,8.88,0,0,0,37.51,63V87.25a1.39,1.39,0,0,0,1.26,1.38h5.36a1.25,1.25,0,0,1,.13,2.49H38.89A3.89,3.89,0,0,1,35,87.45V63.22A11.41,11.41,0,0,1,46.11,51.83h7.41Z" transform="translate(-35 -29)" fill="#0e497b"/>
      <path d="M70.78,78.7A1.26,1.26,0,0,1,72,79.82v7.63a3.89,3.89,0,0,1-3.69,3.68H64.17v20.79a1.26,1.26,0,0,1-1.12,1.25h-.13a1.24,1.24,0,0,1-1.24-1.12V89.89a1.26,1.26,0,0,1,1.12-1.25h5.35a1.39,1.39,0,0,0,1.39-1.26V80A1.25,1.25,0,0,1,70.78,78.7Z" transform="translate(-35 -29)" fill="#0e497b"/>
      <polygon points="29.17 80.83 29.17 94.36 26.67 94.36 26.67 80.83 29.17 80.83" fill="#0e497b"/>
      <path d="M60.63,51.83A11.4,11.4,0,0,1,72,62.93v1.91a1.25,1.25,0,0,1-2.49.12V63.22a8.9,8.9,0,0,0-8.63-8.89H53.52a1.25,1.25,0,0,1-.13-2.5h7.24Z" transform="translate(-35 -29)" fill="#0e497b"/>
      <g>
        <line x1="18.52" y1="82.94" x2="18.52" y2="94.33" fill="none"/>
        <polygon points="19.77 82.94 19.77 94.33 17.27 94.33 17.27 82.94 19.77 82.94" fill="#0e497b"/>
      </g>
      <g>
        <line x1="18.52" y1="60.83" x2="18.52" y2="82.94" fill="none"/>
        <path d="M53.52,88.58a1.25,1.25,0,0,1,1.24,1.12v22.23a1.24,1.24,0,0,1-1.25,1.25,1.26,1.26,0,0,1-1.25-1.12V89.83A1.25,1.25,0,0,1,53.52,88.58Z" transform="translate(-35 -29)" fill="#0e497b"/>
      </g>
      <g>
        <line x1="9.12" y1="82.94" x2="9.12" y2="94.33" fill="none"/>
        <polygon points="10.37 82.94 10.37 94.33 7.87 94.33 7.87 82.94 10.37 82.94" fill="#0e497b"/>
      </g>
      <g>
        <line x1="28.6" y1="80.72" x2="28.6" y2="94.25" fill="none"/>
      </g>
      <g>
        <line x1="9.12" y1="39.5" x2="9.12" y2="82.94" fill="none"/>
        <path d="M44.12,67.25a1.26,1.26,0,0,1,1.25,1.12v43.57a1.25,1.25,0,0,1-2.49.12V68.5A1.25,1.25,0,0,1,44.12,67.25Z" transform="translate(-35 -29)" fill="#0e497b"/>
      </g>
      <path d="M53.52,29a9.83,9.83,0,1,0,9.83,9.83A9.83,9.83,0,0,0,53.52,29Zm0,2.5a7.33,7.33,0,1,1-7.32,7.33A7.33,7.33,0,0,1,53.52,31.5Z" transform="translate(-35 -29)" fill="#0e497b"/>
      <path d="M108.75,51.83a11.4,11.4,0,0,1,11.4,11.1V87.45a3.89,3.89,0,0,1-3.69,3.68H111a1.25,1.25,0,0,1-.12-2.5h5.35a1.39,1.39,0,0,0,1.39-1.26V63.49a.33.33,0,0,1,0-.19l0-.08h-.09A8.9,8.9,0,0,0,109,54.33h-7.38a1.25,1.25,0,0,1-.13-2.5h7.24Z" transform="translate(-35 -29)" fill="#0e497b"/>
      <path d="M84.37,78.7a1.24,1.24,0,0,1,1.24,1.12v7.43a1.39,1.39,0,0,0,1.26,1.38h5.36a1.25,1.25,0,0,1,1.24,1.12v22.17a1.25,1.25,0,0,1-2.5.13V91.14H87a3.89,3.89,0,0,1-3.88-3.69V80A1.25,1.25,0,0,1,84.37,78.7Z" transform="translate(-35 -29)" fill="#0e497b"/>
      <polygon points="58.49 80.81 58.49 94.33 55.99 94.33 55.99 80.81 58.49 80.81" fill="#0e497b"/>
      <path d="M101.64,51.83a1.25,1.25,0,0,1,.12,2.49H94.52A8.9,8.9,0,0,0,85.62,63v1.88a1.25,1.25,0,0,1-2.49.12v-2a11.4,11.4,0,0,1,11.11-11.1h7.41Z" transform="translate(-35 -29)" fill="#0e497b"/>
      <g>
        <line x1="66.64" y1="82.94" x2="66.64" y2="94.33" fill="none"/>
        <polygon points="67.89 82.94 67.89 94.33 65.39 94.33 65.39 82.94 67.89 82.94" fill="#0e497b"/>
      </g>
      <g>
        <line x1="66.64" y1="60.83" x2="66.64" y2="82.94" fill="none"/>
        <path d="M101.64,88.58a1.25,1.25,0,0,1,1.24,1.12v22.23a1.24,1.24,0,0,1-1.25,1.25,1.26,1.26,0,0,1-1.25-1.12V89.83A1.25,1.25,0,0,1,101.64,88.58Z" transform="translate(-35 -29)" fill="#0e497b"/>
      </g>
      <g>
        <line x1="76.03" y1="82.94" x2="76.03" y2="94.33" fill="none"/>
        <polygon points="77.28 82.94 77.28 94.33 74.78 94.33 74.78 82.94 77.28 82.94" fill="#0e497b"/>
      </g>
      <g>
        <line x1="76.03" y1="39.5" x2="76.03" y2="82.94" fill="none"/>
        <path d="M111,67.25a1.26,1.26,0,0,1,1.25,1.12v43.57a1.25,1.25,0,0,1-2.49.12V68.5A1.25,1.25,0,0,1,111,67.25Z" transform="translate(-35 -29)" fill="#0e497b"/>
      </g>
      <path d="M101.63,29a9.83,9.83,0,1,0,9.83,9.83A9.82,9.82,0,0,0,101.63,29Zm0,2.5a7.33,7.33,0,1,1-7.32,7.33A7.33,7.33,0,0,1,101.63,31.5Z" transform="translate(-35 -29)" fill="#0e497b"/>
      <path d="M100.18,71a1.5,1.5,0,0,1,.15,3H53.47a1.5,1.5,0,0,1-.14-3h46.85Z" transform="translate(-35 -29)" fill="#ffb81c"/>
      <path d="M95.32,64.24a1.49,1.49,0,0,1,2-.06l.11.1,6.9,7.22a1.49,1.49,0,0,1,.09,2l-.09.11-6.77,7.08a1.5,1.5,0,0,1-2.27-2l.1-.12,5.78-6-5.91-6.17a1.5,1.5,0,0,1-.06-2Z" transform="translate(-35 -29)" fill="#ffb81c"/>
    </g>
</svg>

    );
  }
}

Icon.displayName = 'TwoPeopleOneWayArrowIcon';

export default Icon;
